/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HouseFilterInput
 */
export interface HouseFilterInput {
    /**
     * 
     * @type {Array<number>}
     * @memberof HouseFilterInput
     */
    ids?: Array<number>;
}

export function HouseFilterInputFromJSON(json: any): HouseFilterInput {
    return HouseFilterInputFromJSONTyped(json, false);
}

export function HouseFilterInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): HouseFilterInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ids': !exists(json, 'ids') ? undefined : json['ids'],
    };
}

export function HouseFilterInputToJSON(value?: HouseFilterInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ids': value.ids,
    };
}

